// Seeded global-search catalog for the ⌘K CommandPalette (mirrors the
// prototype's CMD_GROUPS). Static for now — the data layer is deferred
// (ARCHITECTURE §7/§8). When RTK Query lands, replace this constant with a
// query hook returning the same { name, items[] } shape and the palette /
// shell wiring stays unchanged. `path` is the React Router target per item.
import { CompassIcon, PieIcon, UserIcon, DocIcon } from '../components/icons/Icons';

export const SEARCH_GROUPS = [
  {
    name: 'Pages',
    items: [
      { id: 'p-dashboard', icon: CompassIcon, title: 'Dashboard', sub: 'Page · overview', path: '/' },
      { id: 'p-portfolio', icon: PieIcon, title: 'My Portfolio', sub: 'Portfolio · treemap view', path: '/portfolio' },
      { id: 'p-manage', icon: UserIcon, title: 'Manage Account', sub: 'Manage · profile, beneficiaries', path: '/manage' },
    ],
  },
  {
    name: 'Funds',
    items: [
      { id: 'f-vffvx', icon: PieIcon, title: 'Vanguard Target Retirement 2050 — VFFVX', sub: 'Fund · 64% of holdings', trail: 'VFFVX', path: '/portfolio' },
      { id: 'f-vtsax', icon: PieIcon, title: 'Vanguard Total Stock Market — VTSAX', sub: 'Fund · 18% of holdings', trail: 'VTSAX', path: '/portfolio' },
      { id: 'f-vtiax', icon: PieIcon, title: 'Vanguard Total International — VTIAX', sub: 'Fund · 12% of holdings', trail: 'VTIAX', path: '/portfolio' },
      { id: 'f-vbtlx', icon: PieIcon, title: 'Vanguard Total Bond — VBTLX', sub: 'Fund · 6% of holdings', trail: 'VBTLX', path: '/portfolio' },
    ],
  },
  {
    name: 'Documents',
    items: [
      { id: 'd-q1', icon: DocIcon, title: 'Q1 2026 Statement', sub: 'Document · PDF · 412 KB', trail: 'PDF', path: '/' },
      { id: 'd-1099r', icon: DocIcon, title: 'Form 1099-R · Tax 2025', sub: 'Document · PDF · new', trail: 'PDF', path: '/' },
    ],
  },
];

export default SEARCH_GROUPS;
